import React, { useState, useEffect } from "react";

//*files
import cssClasses from "./ScheduleSiteVisit.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";

//*MUI
import { Box, Modal } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { addLeadLogs, getProjects } from "../../Services/Lead";

import {
  scheduledSiteVisit,
  updateLeadStatus,
} from "../../Services/SiteVisitSchedule";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";

import { useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { Network } from "@capacitor/network";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    top: "0rem",
    right: "1rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
}));

function ScheduleSiteVisit({ open, handleClose, data, returnRes }) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [projectNameList, setProjectNameList] = useState([]);
  const [scheduleData, setScheduleData] = useState({
    projectName: "",
    dateTime: "",
    mode: "Onsite",
    customerRequirement: "",
    projectId: "",
  });
  const [helperText, setHelperText] = useState({
    projectName: "",
    dateTime: "",
    mode: "",
    customerRequirement: "",
  });

  const classes = useStyles();
  useEffect(() => {
    Network.getStatus().then((status) => {
      if (status.connected) {
    getProjects()
      .then((resp) => {
        setProjectNameList(resp);
      })
      .catch((err) => {
        console.log(err);
      });
    }else{
      offlineToast();
    }});
  }, []);

  function closeModal() {
    handleClose();
  }
  function validate() {
    var form = true;
    if (scheduleData.projectName === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.projectName = "Please select project name";
        return { ...preValue };
      });
    }
    if (scheduleData.dateTime === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.dateTime = "Please select date time";
        return { ...preValue };
      });
    }
    if (scheduleData.mode === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.mode = "Please select mode";
        return { ...preValue };
      });
    }
    // if (scheduleData.customerRequirement === "") {
    //   form = false;
    //   setHelperText((preValue) => {
    //     preValue.customerRequirement = "Please enter customer requirement";
    //     return { ...preValue };
    //   });
    // }

    return {
      flag: form,
    };
  }
  function submit() {
    console.log(
      scheduleData,
      data.leadId,
      data.CP.cpId,
      loggedInUser.userId,
      data,
      "fosId",
      data.FOS.fosId
    );
    let flag = validate();
    if (flag.flag) {
      Network.getStatus().then((status) => {
        if (status.connected) {
      presentLoader();
      scheduledSiteVisit(
        scheduleData,
        data.leadId,
        data.CP.cpId,
        loggedInUser.userId,
        data.FOS.fosId
      )
        .then((resp) => {
          console.log(resp);
          updateLeadStatus(data.leadId)
            .then((resp) => {
              let obj={
                cpId:data.cpid,
                fosId:data.fosid,
                userId:loggedInUser.userId,
                leadId:data.leadId,
                leadStatus:resp[0].status,
                message:`Site visit scheduled for ${scheduleData.projectName} on
                ${new Date(scheduleData.dateTime).toDateString()},
                    ${new Date(scheduleData.dateTime).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                by ${loggedInUser.name}(${loggedInUser.roleId.title})`
              }
              addLeadLogs(obj).then((leadLog)=>{console.log(leadLog)}).catch((err)=>{console.log('leadlog',err)})
              dismissLoader();
              successTost(` Site Visit for ${data.leadname} schedule successfully!`);
              returnRes(true);
              dismissLoader();
              closeModal();
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err.message);
            });
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
      }else{
        offlineToast();
      }});
    }
  }
  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            closeModal();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={[
          {
            ".MuiBackdrop-root": {
              background: "rgba(52, 64, 84, 0.7)",
            },
          },
        ]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.wrapperHeader}>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.2rem"} height={"1.2rem"} />
            </span>
            <div>Schedule Site Visit</div>
          </div>
          <Box margin={"2rem"}>
          <div className={cssClasses.wrapperContent} >
            <div className={cssClasses.wrapperBlock}>
              <div className={cssClasses.blockLabel}>
                Select Project <span style={{ color: "red" }}> *</span>
              </div>
              <div className={cssClasses.wrapperdropDown}  style={{width:'100%'}}>
                <DropDown
                  list={projectNameList.map((element, id) => {
                    return {
                      label: element.projectName,
                      value: element.projectName,
                    };
                  })}
                  onChangeSelect={(value) => {
                    setScheduleData((pre) => {
                      pre.projectName = value;
                      return { ...pre };
                    });
                    setHelperText((pre) => {
                      pre.projectName = "";
                      return { ...pre };
                    });
                    let selectedProject;
                    selectedProject = projectNameList.filter(
                      ({ projectName }) => value === projectName
                    );
                    console.log(projectNameList, selectedProject[0].projectId);
                    setScheduleData((pre) => {
                      pre.projectId = selectedProject[0].projectId;
                      return { ...pre };
                    });
                  }}
                  selectedValue={scheduleData.projectName}
                  placeHolder={"Select Project"}
                  //style.color is placeHolder's color
                  style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                  helperText={helperText.projectName}
                />
              </div>
            </div>
            <div className={cssClasses.wrapperBlocks}>
              <div className={cssClasses.wrapperSubBlock} style={{width:'100%' }}>
                <div className={cssClasses.blockLabel} style={{marginRight:'1rem'}}>
                  Site Visit Date
                  <span style={{ color: "red" }}> *</span>
                </div>
                <Box width={'100%'}>
                <DateComponent
                value={scheduleData.dateTime}
                  onChangeDate={(value) => {
                    setScheduleData((pre) => {
                      pre.dateTime = value;
                      return { ...pre };
                    });
                    setHelperText((pre) => {
                      pre.dateTime = "";
                      return { ...pre };
                    });
                  }}
                  helperText={helperText.dateTime}
                />
                </Box>
                
              </div>
              
            </div>
            <div className={cssClasses.wrapperBlock}>
              <div className={cssClasses.blockLabel}>
              Select Mode 
              </div>
              <div className={cssClasses.wrapperdropDown}  style={{width:'100%'}}>
                  <DropDown
                    list={["online", "offline"]}
                    selectedValue={scheduleData.mode}
                    onChangeSelect={(value) => {
                      setScheduleData((pre) => {
                        pre.mode = value;
                        return { ...pre };
                      });
                      setHelperText((pre) => {
                        pre.mode = "";
                        return { ...pre };
                      });
                      //setValue
                    }}
                    placeHolder="Select Mode"
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.mode}
                  />
              </div>
            </div>
            {/* <div className={cssClasses.wrapperSubBlock} style={{width:'100%%'}}>
                <div className={cssClasses.blockLabel} style={{marginRight:'3rem'}}>
                  Select Mode
                 
                </div>
                <div className={cssClasses.wrapperModeDropDown}>
                  <DropDown
                    list={["online", "offline"]}
                    selectedValue={scheduleData.mode}
                    onChangeSelect={(value) => {
                      setScheduleData((pre) => {
                        pre.mode = value;
                        return { ...pre };
                      });
                      setHelperText((pre) => {
                        pre.mode = "";
                        return { ...pre };
                      });
                      //setValue
                    }}
                    placeHolder="Select Mode"
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.mode}
                  />
                </div>
              </div> */}

            <div className={cssClasses.wrapperBlock} style={{marginBottom:'1rem'}}>
              <div
                className={cssClasses.blockLabel}
                style={{ width: "100%", textAlign: "left" }}
              >
                Add Customer requirement:{" "}
                {/* <span style={{ color: "red" }}> *</span> */}
                <div style={{ width: "100%", marginTop: "1rem" }}>
                  <TextField
                    value={scheduleData.customerRequirement}
                    onChange={(e) => {
                      e.target.value = e.target.value.trimStart();
                      if (e.target.value.length <= 200) {
                        setScheduleData((pre) => {
                          pre.customerRequirement = e.target.value;
                          return { ...pre };
                        });
                      }
                      // if (e.target.value.length === 0) {
                      //   setHelperText((pre) => {
                      //     pre.customerRequirement =
                      //       "Please enter customer requirement";
                      //     return { ...pre };
                      //   });
                      // } else {
                      //   setHelperText((pre) => {
                      //     pre.customerRequirement = "";
                      //     return { ...pre };
                      //   });
                      // }
                    }}
                    placeholder={"Type..."}
                    helperText={helperText.customerRequirement}
                    error={helperText.customerRequirement !== ""}
                    className={classes.TextFieldStyle}
                    InputProps={{
                      className: classes.inputStyle,
                    }}
                    inputProps={{ min: 0 }}
                    FormHelperTextProps={{ className: classes.helperText }}
                    multiline
                  />
                  {/* <CustomInput
                    inputType={"TextArea"}
                    value={scheduleData.customerRequirement}
                    handleChange={(newValue) => {
                      console.log(newValue);
                    //  newValue = newValue.trimStart();
                      if (newValue <= 200) {
                        setScheduleData((pre) => {
                          pre.customerRequirement = newValue;
                          return { ...pre };
                        });
                        setHelperText((pre) => {
                          pre.customerRequirement = "";
                          return { ...pre };
                        });
                      }
                      if (newValue.length === 0) {
                        setHelperText((pre) => {
                          pre.customerRequirement =
                            "Please enter customer requirement";
                          return { ...pre };
                        });
                      } else {
                        setHelperText((pre) => {
                          pre.customerRequirement = "";
                          return { ...pre };
                        });
                      }
                    }}
                    helperText={helperText.customerRequirement}
                  /> */}
                </div>
              </div>
            </div>
          </div>
          </Box>
          
          <div className={cssClasses.wrapperFooter}>
            <div>
              <Button
                style={{
                  color: "#344054",
                  backgroundColor: "#ffffff",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Cancel"}
                clicked={handleClose}
              />
            </div>
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Save"}
                clicked={submit}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ScheduleSiteVisit;
